<template>
    <div>
        <!--栏目数据-->
        <div class="index-content-wrap" v-if="columnList.length>0">
            <div class="index-cloumn" v-for="(columnItem, index) in columnList" :key="index">
                <div class="title">
                    <div class="line"></div>
                    <span>{{columnItem.bannerColumName}}</span>
                    <div class="line"></div>
                </div>
                <!--栏目图片-->
                <div class="cloumn-img dg-no-photo" v-if="columnItem.bannerColumImage.length > 0">
                    <img :src="columnItem.bannerColumImage[0].url" alt v-if="columnItem.bannerColumImage[0].url" />
                </div>
                <!-- 栏目列表  默认显示4条  点击更多，加载全部 -->
                <div>
                    <ul class="cloumn-product" :class="columnItem.active ? 'on' : ''">
                        <li v-for="(item, i) in columnItem.commodity_doc" :key="i">
                            <router-link :to="{path:'/product-detail',query:{id:item._id}}">
                                <div class="p-img dg-no-photo">
                                    <img :src="item.comImage[0].url" alt v-if="item.comImage[0].url" />
                                </div>
                                <p class="p-name">
                                    <span class="group_tag" v-if="item.groupBuy.groupBuyComm">[拼团购]</span>
                                    {{item.comName}}
                                </p>
                                <div class="btn-box">
                                    <span class="price">
                                        <i>JPY</i>
                                        {{item.price || '未知' | setNumber}}
                                    </span>
                                    <div class="buy-btn">购买</div>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div
                    class="cloumn-more"
                    @click="columItemShowList(index)"
                    v-if="columnItem.commodity_doc.length > 4"
                >{{columnItem.active ? '收起' : '查看更多'}}</div>
            </div>
        </div>
        <div v-else class="dg-no-data">暂无数据</div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showAll: false,
            text: '',
            columnData: []
        };
    },
    props: ["columnList"],
    methods: {
        // 点击更多展示图片
        columItemShowList(index) {
            if (this.columnList[index].active) {
                this.$set(this.columnList[index], 'active', false)
            } else {
                this.$set(this.columnList[index], 'active', true)
            }
        }
    },
};
</script>

<style lang="scss">
.index-content-wrap {
    width: 100%;
    height: auto;
    padding: 40px 30px 150px 30px;
}
.index-cloumn {
    text-align: center;
    margin-bottom: 40px;
    &:before {
        content: "";
        display: inline-block;
        height: 100%;
        vertical-align: middle;
        margin-right: -0.25em; /* Adjusts for spacing */
    }
    .title {
        width: auto;
        height: 36px;
        display: inline-block;
        line-height: 1;
        vertical-align: middle;
        span {
            font-size: 36px;
            font-weight: bold;
            float: left;
        }
    }
    .line {
        width: 40px;
        height: 6px;
        background: $fc03;
        margin: 15px 20px 0 20px;
        float: left;
    }
    .cloumn-img {
        width: 100%;
        height: 220px;
        border-radius: $br30;
        margin-top: 30px;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .cloumn-product {
        width: calc(100% + 10px);
        max-height: 910px;
        display: flex;
        flex-flow: wrap;
        overflow: hidden;
        transition: height 0.5s linear;
        li {
            flex: 0 0 calc(50% - 10px);
            height: 440px;
            margin-right: 10px;
            margin-top: 10px;
            background: $bg02;
            border-radius: $br30;
            overflow: hidden;
            box-shadow: $box-shadow3;
        }
        .p-img {
            width: 100%;
            height: 310px;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .p-name {
            .group_tag {
                color: $fc04;
            }
            width: 100%;
            height: 24px;
            color: $fc03;
            display: block;
            padding: 0 15px;
            line-height: 1;
            margin-top: 20px;
            text-align: left;
            @include ellipsis();
        }
        .btn-box {
            width: 100%;
            height: 44px;
            line-height: 44px;
            display: flex;
            padding: 0 15px;
            margin-top: 20px;
            .price {
                flex: 1;
                font-size: 28px;
                color: $fc04;
                text-align: left;
                i {
                    font-style: normal;
                    font-size: 22px;
                }
            }
            .buy-btn {
                width: 120px;
                height: 100%;
                border-radius: $br30;
                background: $btn01;
                color: $fc02;
                text-align: center;
                &:active {
                    background: $btnHover01;
                }
            }
        }
    }
    .on {
        height: auto;
        max-height: 100000px;
        transition: height 0.5s linear;
    }
    .cloumn-more {
        width: calc(100% - 40px);
        padding: 40px 0 20px;
        border-bottom: 1px solid $bc01;
        text-align: center;
        font-size: 28px;
        color: red;
        margin: 0 auto;
        &:active {
            color: $fc07;
        }
    }
}
</style>
